module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('popup-select', {
    ref: "popupSelect",
    attrs: {
      "custom": true,
      "title": '选择院区',
      "forced": _vm.forced
    }
  }, [_c('div', {
    attrs: {
      "slot": "custom"
    },
    slot: "custom"
  }, [_c('ul', {
    staticClass: "list list-header"
  }, [_c('li', {
    staticClass: "list-item last ellipsis"
  }, [_vm._v("请选择您要导航去的院区")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.areaList), function(area, index) {
    return _c('li', {
      key: index,
      staticClass: "list-item arr-row",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectArea(area)
        }
      }
    }, [_c('div', {
      staticClass: "hospital-info"
    }, [_c('div', {
      staticClass: "logo",
      style: ({
        backgroundImage: 'url(' + _vm.selectedHospital.hospitalLogo + ')',
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "f-large f-normal ellipsis"
    }, [_vm._v(_vm._s(area.areaName))]), _vm._v(" "), _c('p', {
      staticClass: "f-small f-dark-gray ellipsis"
    }, [_vm._v(_vm._s(area.areaAddr))])])])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-719bd549","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/areaSelect/AreaSelect.vue
// module id = 851
// module chunks = 0